import axios from './axiosConfig';
import { API_URL } from "utils/constants";

const login = (email, password) => {
  
  return axios
    .post(API_URL + "auth/token/login/", {
      email,
      password,
    })
    .then((response) => {
      if (response.data.auth_token) {
        localStorage.setItem("token", JSON.stringify(response.data));
      }

      return response;
    });
};

const logout = () => {
  localStorage.removeItem("token");
};

const authObject = { login, logout };

export default authObject;
